import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TuiDataList, TuiDropdown } from '@taiga-ui/core';
import { TuiMultiSelectModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy';
import { TuiChip, TuiDataListWrapper } from '@taiga-ui/kit';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Label } from '@ffx/common';
import { TUI_DEFAULT_MATCHER, tuiPure } from '@taiga-ui/cdk';
import { ProjectStore } from '@ffx/app-store';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'ffx-label-dropdown-chips',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TuiDataList,
        TuiDataListWrapper,
        TuiDropdown,
        TuiMultiSelectModule,
        TuiTextfieldControllerModule,
        TuiChip
    ],
    templateUrl: './label-dropdown-chips.component.html',
    styleUrl: './label-dropdown-chips.component.scss'
})
export class LabelDropdownChipsComponent implements OnInit {
    @Input() selectedLabelIcons: Label[] = [];
    @Output() labelIconsOutput = new EventEmitter<Label[]>();

    private projectStore = inject(ProjectStore);
    projectStoreLabels = this.projectStore.labels;

    labelControl = new FormControl([] as string[]);
    allLabels: string[] = [];
    protected search: string | null = '';

    constructor() {
        this.labelControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((selectedLabels) => {
            if (selectedLabels) {
                this.updateSelectedIcons(selectedLabels);
            }
        });
    }

    ngOnInit(): void {
        this.allLabels = this.projectStoreLabels().map((label) => label.name);
        this.labelControl.setValue(this.selectedLabelIcons.map((item) => item.name));
    }

    private updateSelectedIcons(selectedLabels: string[]): void {
        this.selectedLabelIcons = selectedLabels.map((labelName) => {
            const foundIcon = this.projectStoreLabels().find((item: Label) => item.name === labelName)?.icon || '';
            return { name: labelName, icon: foundIcon };
        });
        this.labelIconsOutput.next(this.selectedLabelIcons);
    }

    @tuiPure
    protected selectLabelIcons(search: string | null): readonly string[] {
        return this.allLabels.filter((item) => TUI_DEFAULT_MATCHER(item, search || ''));
    }

    getIconByLabel(labelName: string): string {
        const item = this.projectStoreLabels().find((label) => label.name === labelName);
        return item ? item.icon : '';
    }
}
